var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoAccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 245,
    height: 145,
    viewBox: "0 0 245 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.5,
    ry: 4.51679,
    transform: "matrix(-1 0 0 1 29.8945 71.0225)",
    fill: "#E3E0FB"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.5,
    ry: 4.51679,
    transform: "matrix(-1 0 0 1 14.3906 43.0082)",
    fill: "#E3E0FB"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 215.125,
    cy: 71.218,
    rx: 4.5,
    ry: 4.51679,
    fill: "#E3E0FB"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 198.785,
    cy: 94.4569,
    rx: 4.5,
    ry: 4.51679,
    fill: "#E3E0FB"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.5,
    ry: 4.51679,
    transform: "matrix(-1 0 0 1 51.0391 48.6744)",
    fill: "#E3E0FB"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.5,
    ry: 4.51679,
    transform: "matrix(-1 0 0 1 42.0391 102.25)",
    fill: "#E3E0FB"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.785,
    cy: 49.3889,
    rx: 4.5,
    ry: 4.51679,
    fill: "#E3E0FB"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.742,
    cy: 96.5583,
    rx: 4.5,
    ry: 4.51679,
    fill: "#E3E0FB"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.5,
    ry: 4.51679,
    transform: "matrix(-1 0 0 1 5.39062 85.6812)",
    fill: "#E3E0FB"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 230.242,
    cy: 51.9048,
    rx: 4.5,
    ry: 4.51679,
    fill: "#E3E0FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181.632 144.169H63.5045C54.2218 144.169 48.1831 134.395 52.334 126.087L111.398 7.90453C116.001 -1.30334 129.136 -1.30334 133.739 7.90453L192.803 126.087C196.953 134.395 190.917 144.169 181.632 144.169Z",
    fill: "#E3E0FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.473 51.5517C117.99 52.2074 116.097 53.9957 114.945 56.7675C114.412 58.1385 114.442 60.046 115.24 73.309C115.595 79.3593 116.068 87.1681 116.275 90.6254C116.718 98.1958 117.014 99.0005 119.675 100.342C121.508 101.295 122.779 101.385 124.375 100.699C126.918 99.6264 128.278 97.1824 128.278 93.7549C128.248 92.831 128.692 84.5453 129.224 75.3357C130.288 56.8867 130.288 57.0357 128.544 54.5023C126.888 52.0584 123.429 50.8066 120.473 51.5517Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.247 107.161C116.617 108.319 114.338 111.558 114.608 115.123C114.938 119.401 118.057 122.312 122.317 122.342C125.377 122.342 127.897 120.797 129.307 118.064C130.087 116.578 130.177 113.221 129.487 111.617C128.827 110.132 127.267 108.438 125.827 107.725C124.507 107.071 121.477 106.745 120.247 107.161Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAccess);
export default __webpack_public_path__ + "static/media/noAccess.63d01f9f99c3f8796aeabb378384f201.svg";
export { ForwardRef as ReactComponent };